import { render, staticRenderFns } from "./ProductServiceCreator.vue?vue&type=template&id=8dc97ec8&scoped=true"
import script from "./ProductServiceCreator.vue?vue&type=script&lang=js"
export * from "./ProductServiceCreator.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceCreator.vue?vue&type=style&index=0&id=8dc97ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc97ec8",
  null
  
)

export default component.exports